/* eslint-disable no-underscore-dangle */
import { Box, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { IPropertyBag } from '@deity-io/di-data-basics';
import { ConfigurationVariables } from '@deity-io/di-data-flows';
import KeyValueTable, { KeyValidators } from 'components/FieldEditorControls/KeyValueTable';
import { Tooltip } from 'components/Tooltip';
import type { FC } from 'react';

interface IControlVariablesProps {
  isEditable?: boolean;
  property: string;
  description?: string;
  controlConfig: IPropertyBag | undefined;
  label?: string;
  error?: boolean;
  onChange?: (key: string, value: IPropertyBag) => void;
  onBlur?: (key: string, value: IPropertyBag) => void;
}
const ControlVariables: FC<IControlVariablesProps> = ({
  isEditable,
  property,
  controlConfig,
  description,
  onBlur,
  onChange,
  label,
  error
}) => {
  controlConfig = controlConfig || {};

  const list = ConfigurationVariables.list(controlConfig);
  const value = controlConfig[property] || {};
  const prefixFilter = 'component.';
  list.forEach(item => {
    const key = item.slice(prefixFilter.length);
    if (!(key in value) && item.startsWith(prefixFilter)) {
      value[key] = undefined;
    }
  });

  if (!Object.keys(value).length) {
    return null;
  }

  return (
    <FlexLayout p="xs" mt="xs" mb="xs" bg="panelLight" borderRadius="small" css={{ minHeight: '78px' }} width="full">
      <FlexLayout alignItems="center" width="full">
        <FlexLayout alignItems="center" width="full" flexDirection="row" justifyContent="space-between" mb="xs">
          <H4 fontWeight="bold" mr="xs" style={{ textTransform: 'capitalize' }}>
            {property}
          </H4>
          {description && (
            <Tooltip key="tooltip" content={description} direction="left">
              <Icon src="helpOutline" color="secondary" stroke="transparent" />
            </Tooltip>
          )}
        </FlexLayout>
        <Box width="full">
          <KeyValueTable
            keyColumnLocked
            key={property}
            isEditable={isEditable !== false}
            keyValidator={KeyValidators.NO_WHITE_SPACE}
            persistedValue={value}
            onTableValueChange={(key, val) => {
              if (onChange) {
                onChange(property, val);
              }
            }}
            onTableValueBlur={(key, val) => {
              if (onBlur) {
                onBlur(property, val);
              }
            }}
            required
            notEmpty
          />
        </Box>
      </FlexLayout>
    </FlexLayout>
  );
};
export default ControlVariables;
